export const PRINTER = 'printer';
export const PRINTER_LIST = PRINTER + '.list';
export const LAYOUT = '.layout';
export const LAYOUT_LIST = LAYOUT + '.list';
